import { Box2, Shape, Vector2, Vector2Tuple } from 'three';

import { pointRotate } from '@spazious/dollhouse-three';

const _box2 = new Box2();
const _size = new Vector2();
const _center = new Vector2();

(window as any).b2 = _box2;

const maskFromPoints = (points: Vector2Tuple[]) => {
  if (!points.length) {
    return [];
  }

  const mapFn = (v: Vector2) => v.toArray();
  const shape = new Shape(points.map((p) => new Vector2().fromArray(p)));
  const outerPoints = shape.getPoints().map(mapFn);
  const holePoints = shape.getPointsHoles(12).map((v) => v.map(mapFn));
  return [outerPoints, ...holePoints];
};

export const maskAndSizeFromPoints = (
  points: Vector2Tuple[],
  theta: number = 0,
  position: Vector2Tuple = [0, 0]
) => {
  // complete the polygon
  let closedLoop = [...points];
  if (
    points.length >= 2 &&
    (points[0][0] !== points[points.length - 1][0] || points[0][1] !== points[points.length - 1][1])
  ) {
    closedLoop.push([...points[0]]);
  }

  if (!closedLoop.length) {
    return {
      center: [0, 0],
      size: [0, 0],
      mask: [],
    };
  }

  // remove rotation
  closedLoop = closedLoop.map((p) => pointRotate(p, theta, position));

  const box = _box2.setFromPoints(closedLoop.map((p) => new Vector2(p[0], p[1])));
  box.getSize(_size);
  box.getCenter(_center);

  // to local co-ordinates
  closedLoop = closedLoop.map((p) => [p[0] - _center.x, p[1] - _center.y] as Vector2Tuple);

  return {
    center: _center.toArray(),
    size: _size.toArray(),
    mask: maskFromPoints(closedLoop),
  };
};
